import { useEffect, useState } from "react";
import { Search } from "lucide-react";
import api from "../../lib/api";

const card = "rounded-2xl border border-adminborder bg-admincard";
const darkInput = "w-full rounded-lg border border-adminborder bg-adminbg px-3.5 py-2.5 text-sm text-slate-200 outline-none focus:border-saffron";

export default function AdminContacts() {
  const [kind, setKind] = useState("all");
  const [q, setQ] = useState("");
  const [contacts, setContacts] = useState([]);

  useEffect(() => {
    const t = setTimeout(() => {
      api.get(`/admin/contacts?kind=${kind}&q=${encodeURIComponent(q)}`)
        .then((r) => setContacts(r.data)).catch(() => {});
    }, 250);
    return () => clearTimeout(t);
  }, [kind, q]);

  return (
    <div data-testid="admin-contacts" className="space-y-6">
      <div className="flex flex-wrap items-end justify-between gap-4">
        <div>
          <h1 className="font-heading text-2xl font-bold tracking-tight text-white sm:text-3xl">Sender & Receiver Database</h1>
          <p className="mt-1 text-sm text-slate-500">Auto-saved from every booking — duplicates merge by phone number.</p>
        </div>
        <div className="flex flex-wrap items-center gap-2">
          {[["all", "All"], ["sender", "Senders"], ["receiver", "Receivers"]].map(([k, label]) => (
            <button key={k} onClick={() => setKind(k)} data-testid={`contact-tab-${k}`}
                    className={`rounded-full px-4 py-2 text-xs font-bold transition-colors ${kind === k ? "bg-saffron text-white" : "border border-adminborder text-slate-400 hover:text-white"}`}>
              {label}
            </button>
          ))}
          <div className="relative">
            <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-500" />
            <input value={q} onChange={(e) => setQ(e.target.value)} data-testid="contact-search"
                   placeholder="Search name, phone, city, pincode…" className={`${darkInput} w-64 pl-9`} />
          </div>
        </div>
      </div>

      <div className={`${card} overflow-x-auto`}>
        <table className="w-full text-sm" data-testid="contacts-table">
          <thead>
            <tr className="border-b border-adminborder text-left text-xs uppercase tracking-wider text-slate-500">
              <th className="px-5 py-3.5">Type</th><th className="px-5 py-3.5">Name</th><th className="px-5 py-3.5">Phone</th>
              <th className="px-5 py-3.5">Address</th><th className="px-5 py-3.5">City / State</th>
              <th className="px-5 py-3.5">Pincode / ZIP</th><th className="px-5 py-3.5">Country</th>
              <th className="px-5 py-3.5">Used</th><th className="px-5 py-3.5">Source</th>
            </tr>
          </thead>
          <tbody>
            {contacts.map((c) => (
              <tr key={c.id} className="border-b border-adminborder/60 last:border-0 hover:bg-white/5" data-testid={`contact-row-${c.id}`}>
                <td className="px-5 py-3.5">
                  <span className={`rounded-full px-2 py-0.5 text-[10px] font-bold ${c.kind === "sender" ? "bg-saffron/15 text-saffron" : "bg-sky-500/15 text-sky-400"}`}>
                    {c.kind === "sender" ? "SENDER" : "RECEIVER"}
                  </span>
                </td>
                <td className="px-5 py-3.5 font-bold text-white">{c.name}</td>
                <td className="px-5 py-3.5 font-mono text-xs text-slate-300">{c.phone}</td>
                <td className="max-w-48 truncate px-5 py-3.5 text-xs text-slate-400">{c.address || "—"}</td>
                <td className="px-5 py-3.5 text-xs text-slate-400">{[c.city, c.state].filter(Boolean).join(", ") || "—"}</td>
                <td className="px-5 py-3.5 text-xs text-slate-400">{c.pincode || c.zipcode || "—"}</td>
                <td className="px-5 py-3.5 text-xs text-slate-400">{c.country || "—"}</td>
                <td className="px-5 py-3.5 text-xs text-slate-400">{c.times_used || 1}×</td>
                <td className="px-5 py-3.5 text-xs capitalize text-slate-500">{c.source || "—"}</td>
              </tr>
            ))}
            {!contacts.length && <tr><td colSpan={9} className="px-5 py-12 text-center text-slate-500">No contacts saved yet — they appear automatically after bookings.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
